module.exports = __webpack_public_path__ + "static/way-of-the-warrior-kid-89dd7d6bb090dd3c81cb84ac6f9f8b75.jpg";